export const ngRepeatAliasDirectiveModule = angular
  .module('Q.components.ng-repeat-alias', [])

  /**
   * @docType shared
   * @category directive
   *
   * @ngdoc directive
   *
   * @name ngRepeatAlias
   * @restrict A
   * @scope
   * @priority 400
   *
   * @description
   * Provides alias(es) for ngRepeat properties. The main reason for this over ngInit is it can handle when the list
   * is using "track by" and gets reordered. With ngInit, the value is never updated.
   *
   * With this method, the values are set on every digest. This ensures that the values will always be up-to-date,
   * but could cause digest errors if you are dealing with a lot of properties.
   *
   * @param {expression} ngRepeatAlias - if just a valid identifier, sets that scope var to $index.
   *     Otherwise should be a hash of { newName: currentName }
   *
   */
  .directive('ngRepeatAlias', function () {
    return {
      restrict: 'A',
      link: function (scope, el, attr) {
        let setValues;
        if (/^[$\w]+$/.test(attr.ngRepeatAlias)) {
          setValues = () => {
            scope[attr.ngRepeatAlias] = scope.$index;
          };
        } else {
          setValues = () => {
            angular.extend(scope, scope.$eval(attr.ngRepeatAlias));
          };
        }
        setValues();
        scope.$watch(setValues);
      },
    };
  });
